import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import UserApi from 'api/user';
import { ApiClientError } from 'api/client';
import { queryKey } from 'constants/queryKey';
import { AccountThunks } from 'modules/account/accountActions';
import Logger from 'utils/logger';
import { InviteUserParams, InviteUserResponse } from 'types/User';

type UseInviteUserMutationOptions = {
  onInvited: (response: InviteUserResponse) => void;
  onSeatLimitError: (error: ApiClientError) => boolean;
};

export function useInviteUserMutation({
  onInvited,
  onSeatLimitError,
}: UseInviteUserMutationOptions) {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const mutation = useMutation<
    InviteUserResponse,
    ApiClientError,
    InviteUserParams
  >((values) => UserApi.sendInvitation(values), {
    onSuccess: (response) => {
      onInvited(response);
      dispatch(AccountThunks.requestAccount());
      queryClient.invalidateQueries(queryKey.usersList());
    },
    onError: (error) => {
      if (onSeatLimitError(error)) {
        mutation.reset();
        return;
      }
      Logger.error(error);
    },
  });

  return mutation;
}
